import { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";
import { PlayCircle, ArrowUpRight } from "lucide-react";
import { VideoFrame } from "@/pages/Testimonianze";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const VideoTestimonials = () => {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    axios.get(`${API}/testimonials`).then(({ data }) => setVideos(data.slice(0, 3))).catch(() => {});
  }, []);

  if (!videos.length) return null;
  return (
    <section id="video-pazienti" className="py-24 md:py-32 px-6 md:px-12 bg-[#15201A]" data-testid="video-testimonials-section">
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <div className="flex flex-wrap items-end justify-between gap-4">
            <div>
              <p className="text-sm uppercase tracking-[0.2em] font-bold text-[#C98E6E] mb-4 flex items-center gap-2">
                <PlayCircle size={18} /> Video testimonianze
              </p>
              <h2 className="font-serif-display font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight text-white max-w-3xl">
                I nostri pazienti, <em className="italic text-[#7D9285]">con la loro voce</em>
              </h2>
            </div>
            <Link to="/testimonianze" className="inline-flex items-center gap-2 text-[#C98E6E] font-bold hover:text-white transition-colors duration-300" data-testid="video-testimonials-all-link">
              Tutte le testimonianze <ArrowUpRight size={18} />
            </Link>
          </div>
          <p className="mt-6 text-base md:text-lg leading-relaxed text-white/60 max-w-2xl">
            Storie vere di chi è tornato a sorridere con il carico immediato, raccontate direttamente dai pazienti.
          </p>
        </Reveal>
        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {videos.map((v, i) => (
            <Reveal key={v.id} delay={i * 0.08}>
              <figure className="group" data-testid={`video-testimonial-${i}`}>
                <VideoFrame video={v} />
                <figcaption className="mt-4 text-white/80 font-semibold text-base">{v.title}</figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
